import { siteFeatures } from '@/mocks/faq';

export default function FeaturesSection() {
  return (
    <section className="w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4">
            核心功能
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4 font-heading">
            免费在线成网站，功能一样不少
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            六大核心功能，覆盖建站全流程。从AI生成到SEO优化，零成本也能做出专业网站。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {siteFeatures.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:bg-background-50"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-3 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}